export function formatDate(dateString: string): string {
  // Handle empty or null date strings
  if (!dateString) {
    return 'Unknown date';
  }

  // Try to create a date object
  let date: Date;
  
  // Handle different date formats
  if (typeof dateString === 'string') {
    // If it's already a valid ISO string or timestamp
    date = new Date(dateString);
  } else {
    // Fallback for other types
    date = new Date(String(dateString));
  }
  
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    // Try parsing as timestamp if it's a number string
    const timestamp = parseInt(dateString);
    if (!isNaN(timestamp)) {
      date = new Date(timestamp);
      if (isNaN(date.getTime())) {
        return 'Invalid date';
      }
    } else {
      return 'Invalid date';
    }
  }

  const options: Intl.DateTimeFormatOptions = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  };
  
  try {
    return date.toLocaleDateString('en-US', options);
  } catch (error) {
    return 'Invalid date';
  }
}
